import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsPrDotCoComponent } from './simple-icons-pr-dot-co.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsPrDotCoComponent ],
    exports:      [ SimpleIconsPrDotCoComponent ],
    bootstrap:    []
})
export class SimpleIconsPrDotCoModule {}
